import React, {useEffect} from 'react';
import {ReactComponent as PlusIcon} from '../../../../../../../assets/main/groups/main-table/period-calendar/plus.svg';
import {useAppDispatch, useAppSelector} from "common/hook";
import {setAddCutAC} from "app/popups-reducer";
import {useParams} from "react-router-dom";
import {
    fetchStudentCuts
} from "features/model/service/student-info/student-info-cuts/fetchStudentInfoCuts";
import {NothingYetMessage} from "../../../../../personal-cabinet/nothing-yet-message/NothingYetMessage";
import {Preloader} from "components/layout/preloader/Preloader";
import {BarChartItem} from "./bar-chart-item/BarChartItem";
import {ROLE_TEACHER} from "entities/constants/constants";


export const StudentsSlices = () => {
    const isAddCut = useAppSelector((state) => state.popups.isAddCut);
    const cutsData = useAppSelector((state) => state.cuts);
    const roleType = useAppSelector((state) => state.role.roleType);
    const {items, isLoading} = cutsData;
    const dispatch = useAppDispatch();
    const {groupId, studentId} = useParams();

    useEffect(() => {
        dispatch(fetchStudentCuts({groupId, studentId}));
    }, []);

    const onClickHandler = () => {
        dispatch(setAddCutAC(!isAddCut));
    };

    return (
        <div className="tabs-content">
            <div className="tab">
                <div className="data-item-title-box">
                    <div className="title-box">
                        <p className="h4">Срезы</p>
                    </div>
                    {roleType === ROLE_TEACHER && (
                        <span className="btn small has-icon" onClick={onClickHandler}>
                          <span className="icon">
                           <PlusIcon />
                                </span>
                             <span className="text">Добавить срез</span>
                        </span>
                    )}

                </div>

                <div className="bar-charts-box">
                    {isLoading ? (
                        <Preloader/>
                    ) : (
                        items && items.length > 0 ? (
                            items.map((cuts) => <BarChartItem key={cuts.id} cuts={cuts}/>)
                        ) : (
                            <NothingYetMessage/>
                        )
                    )}
                </div>
            </div>
        </div>
    );
};

